import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

import { ucFirst } from 'utils/helpers';
import { userSelectors } from 'reducers';
import { texts } from 'utils/languages/fr';

import DashboardTitle from './DashboardTitle';
import { Box } from '@mui/material';

const DashboardTemplate = ({ children, useDahboardPageTitle }) => {
    const internalUser = useSelector(userSelectors.getInternalUser);

    return (
        <Box
            width="100%"
            padding={3}
            minHeight={theme => `calc(100% - ${theme.constants.footerHeight}px)`}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <DashboardTitle>
                    {useDahboardPageTitle
                        ? texts.DASHBOARD
                        : `${texts.BIENVENUE} ${ucFirst(internalUser.firstName)},`}
                </DashboardTitle>
            </Box>
            {children}
        </Box>
    );
};

DashboardTemplate.propTypes = {
    useDahboardPageTitle: PropTypes.bool,
    children: PropTypes.node,
};

export default DashboardTemplate;
